module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/site_logo_large-442818bb631e557f026e598f0c2f06d7.png";